import React from "react";
import { observer } from "mobx-react-lite";

import { ButtonsSection } from "../../../components/data-components/sections/DataSections";
import { translationService } from "../../../services/translation/TranslationService";
import AcceptCollaborationButton from "./buttons/AcceptCollaborationButton";

export default observer(function AcceptCollaboration() {
  return (
    <div className="option-container">
      <div className="title">{translationService.translate("LandingPage.collaboration")}</div>
      <div className="description">
        {translationService.translate("LandingPage.collaboration-description")}
      </div>
      <ButtonsSection>
        <AcceptCollaborationButton />
      </ButtonsSection>
    </div>
  );
});
